import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';
import { LearnMoreInlineLink } from 'components/DataDisplay/KnowledgeBase/BaseComponents/LearnMoreInlineLink';
import { useKnowledgeBase } from 'components/DataDisplay/KnowledgeBase/hook/useKnowledgeBase';

export const LearnMoreAboutTicketing: FC = () => {
  const navigate = useNavigate();
  const { setLearnMore } = useKnowledgeBase();
  const links: KnowledgeBaseLink[] = [
    { label: 'Findings', field: 'findings' },
    { label: 'Issues', field: 'issues' },
    { label: 'Remediation', field: 'remediation' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="ticketing"
      headerTitle="Ticketing"
      body={
        <Stack spacing={10}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Description</Text>
            <Text>
              Ariksa integrates into your existing enterprise workflow to create
              and route tickets to owners for all detections of policy
              violations that generate issues . We currently support JIRA and
              ServiceNow for ticketing. When creating tickets, we automatically
              populates tickets with information from each{' '}
              <LearnMoreInlineLink label="issue" field="issues" value /> that’s
              required for further investigation, triaging and remediation.
            </Text>
            <Text pt={2}>
              Additionally, we also automatically track changes made to tickets
              from updates and resolution. You can view all existing tickets
              from{' '}
              <Text
                display="inline-block"
                color="primary"
                cursor="pointer"
                onClick={() => {
                  setLearnMore();
                  navigate('/findings/tickets');
                }}
              >
                Findings / Tickets
              </Text>
              .
            </Text>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
